<template>
    <div>
        <aIntroSlides v-if="isMobile==true && isIntroVisited!='true'" @introSlides="introSlides"></aIntroSlides>
        <div v-if="isMobile?isIntroVisited:true">
            <CContainer class="min-vh-100 d-flex align-items-center mob-res-pd0 mob-ai-flex-start mob-bg-white">
                <CRow class="w-100 justify-content-center form-wrapper-mf mob-m0 login-form mt-70px">
                    <CCol md="4" class="form-left">
                        <div class="form-right-title">
                            {{$t('loginPg.noAcct')}}
                        </div>
                        <div class="form-sub-message">{{$t('loginPg.fillIn')}}</div>
                        <button class="mf-secondary-btn" @click="navigateToReg">{{$t('loginPg.reg')}}</button>
                    </CCol>

                    <CCol md="8" class="mob-res-form-bg">
                        <div class="logo-wrapper align-center">
                            <!-- <img src="@imgPath/img/png/Logo-Maing-Fong.jpg" alt=""> -->

                            <span class="brand-logo" >
<!--                             <img :src="getImage('Logo-Maing-Fong')" alt="">-->
                            </span>

                        </div>

                        <ValidationObserver v-slot="{ handleSubmit }" v-if="showLogin">
                            <div class="form-wrapper">
                                <div class="form-title">
                                    <!-- <strong> -->
                                    {{$t('loginPg.loginTitle')}}
                                    <!-- </strong> -->
                                </div>
                                <form @submit.prevent="handleSubmit(loginFormSubmit)">
                                    <div>


                                        <!-- Login part -->
                                        <!-- <div v-if="showLogin"> -->
                                        <div class="form-field">

                                            <cTextInputComponent
                                                    v-model="logDet.logMail"
                                                    :placeholder="$t('loginPg.emailPl')"
                                                    rules="required|email"
                                                    :rule="showError"
                                                    :label="$t('loginPg.email')"
                                            />
                                        </div>
                                        <div class="form-field p-relative">

                                            <!-- Captcha part -->
                                            <div>
                                                <cTextInputComponent
                                                        v-model="logDet.logPwd"
                                                        :placeholder="$t('loginPg.pwdPl')"
                                                        :type="pwdType"
                                                        rules="required"
                                                        :rule="showError"
                                                        :label="$t('loginPg.pwd')"
                                                />
                                                <div class="icon-show" @click="togglePwdType()">
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                         xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                                                         id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512"
                                                         style="enable-background:new 0 0 512 512;"
                                                         xml:space="preserve">
<g>
	<g>
		<path d="M508.177,245.995C503.607,240.897,393.682,121,256,121S8.394,240.897,3.823,245.995c-5.098,5.698-5.098,14.312,0,20.01    C8.394,271.103,118.32,391,256,391s247.606-119.897,252.177-124.995C513.274,260.307,513.274,251.693,508.177,245.995z M256,361    c-57.891,0-105-47.109-105-105s47.109-105,105-105s105,47.109,105,105S313.891,361,256,361z"/>
	</g>
</g>
                                                        <g>
	<g>
		<path d="M271,226c0-15.09,7.491-28.365,18.887-36.53C279.661,184.235,268.255,181,256,181c-41.353,0-75,33.647-75,75    c0,41.353,33.647,75,75,75c37.024,0,67.668-27.034,73.722-62.358C299.516,278.367,271,255.522,271,226z"/>
	</g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
                                                        <g>
</g>
</svg>
                                                </div>
                                            </div>

                                            <div v-if="showCaptcha">
                                                <cTextInputComponent
                                                        v-model="logDet.captcha"
                                                        :placeholder="$t('loginPg.cptPl')"
                                                        rules="required"
                                                />
                                               
                                                <cCaptcha ref="agtCaptchaComponent" iconName="cil-reload"
                                                          class="grey-border-mf captcha agent-captcha" />
                                                         
                                            </div>


                                        </div>

                                        <!-- Alert part -->
                                        <!-- <div > -->
                                        <!-- <CAlert v-if="showAlert" show color="danger">{{alertValue}}</CAlert> -->
                                      
                             <CAlert v-if="showAlert" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>           
                                        <!-- </div> -->


                                        <div class="form-field align-right mt-25px">


                                            <CButton
                                                    pressed
                                                    block
                                                    color="success"
                                                    type="submit"
                                                    @click="showError=false"
                                                    class="btn-primary-mf">{{$t('loginPg.login')}}
                                            </CButton>
                                        </div>
                                        <CButton

                                                @click="showLogin=false,showError=true"
                                                class="px-0 removewrap forget-password"
                                        >{{$t('loginPg.frgtPwd')}}
                                        </CButton>

                                        <!-- <CCol col="15" class="text-center">
                                          {{$t('loginPg.noAcct')}}
                                          <u>
                                            <a style="color:Blue;" @click="navigateToReg">{{$t('loginPg.reg')}}</a>
                                          </u>
                                        </CCol> -->

                                    </div>
                                </form>
                            </div>
                        </ValidationObserver>
                        <div>
                            <ValidationObserver v-slot="{ handleSubmit }" v-if="!showLogin">
                                <form @submit.prevent="handleSubmit(forgotFormSubmit)">
                                    <div class="form-wrapper">
                                        <div class="form-title">
                                            <!-- <strong> -->
                                            {{$t('forgtPwd.frgtPwdTxt')}}
                                            <!-- </strong> -->
                                        </div>


                                        <p class="text-center">{{$t('forgtPwd.enterMail')}}</p>
                                        <div class="form-field">
                                            <cTextInputComponent
                                                    v-model="frgtPwd.mail"
                                                    :placeholder="$t('forgtPwd.fgMailPl')"
                                                    rules="required|email"
                                                    label="Email"
                                                    :rule="showError"
                                                    @input="frgtPwdAlert=null"
                                            />
                                        </div>
                                         <div v-if="frgtPwdAlert">

                                              <CAlert v-if="frgtPwdAlert" show color="danger">
                      <div  v-if="frgtPwdAlert&&frgtPwdAlert.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in frgtPwdAlert.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="frgtPwdAlert&&frgtPwdAlert.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in frgtPwdAlert.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="frgtPwdAlert&&frgtPwdAlert.constructor==String">
                <p  >
                        {{frgtPwdAlert}}
                      </p>
                      </div>
                      </CAlert>  
                                            <!-- <CAlert v-if="frgtPwdAlert" show color="danger">{{frgtPwdAlert}}</CAlert> -->
                                            <br/>
                                        </div>
                                        <div v-if="resetPwd">
                                            <p class="text-center">{{$t('forgtPwd.resetTxt')}}</p>
                                            <br/>
                                        </div>
                                        <div class="form-field align-right">

                                            <CButton
                                                    class="btn-primary-mf w-auto"
                                                    pressed
                                                    block
                                                    color="success"
                                                    type="submit"
                                                    @click="showError=false"
                                            >{{$t('forgtPwd.resetPwd')}}
                                            </CButton>

                                        </div>
                                    </div>
                                    <br/>
                                    <CRow class="d-flex justify-content-center">
                                        <CCol col="9.5" class="top-header">
                                            <!-- <div > -->
                                            {{$t('forgtPwd.backTo')}}
                                        </CCol>
                                        <CCol col="2.5" class="top-header-link">
                                            <u>
                                                <p
                                                        class="c-primary d-i-block c-pointer"
                                                        @click="showLogin=true,resetPwd=false,showError=true,frgtPwd.mail=null"
                                                >{{$t('forgtPwd.login')}}</p>
                                            </u>
                                            <!-- </div> -->
                                        </CCol>
                                    </CRow>
                                      
                                    <!-- {{mail}} -->
                                    <br/>
                                    <br/>
                                </form>
                            </ValidationObserver>
                        </div>


                    </CCol>

                </CRow>
            </CContainer>
        </div>

        <cAlertModal v-if="pwdRest"
                :buttonList="[{name:$t('forgtPwd.login'),
func:navigateToLogin,color:'success'}]"
                :status="1"
                :show="pwdRest"
                :desc="(( $t('forgtPwd.mailSuccess')) )"

        ></cAlertModal>
    </div>
</template>

<script>
import {  handleJWT, getErrorAlertValue, cloneData ,addClassToBody,removeClassBody, getSettings} from "../../util/util";

    import {PAGE_NAME} from "../../util/constants.js";
    import {ValidationObserver, localize} from "vee-validate";
    import {mapActions} from "vuex";
    import cCaptcha from "../../components/form/cCaptcha";
    import cAlertModal from "../../components/form/cAlertModal";
    import router, {navigate, goBack,updateCurrRouteQuery,navigateReplace} from "../../router/index";
    import {mapGetters} from "vuex";
    import cTextInputComponent from "../../components/form/cTextInputComponent";
    // import nb from "../../translations/validation/nb.json";
    // import en from "../../translations/validation/en.json";
    import {sign} from "crypto";
    import apiSignIn from "../../services/apiSignIn.js";
    import Logger from "../../services/logger";
    import {LOG_TYPE, FILE_NAME, HTTP_CODES} from "../../config/API_DATA";
    import {COMPONENT_NAME, PATHNAME, PASSWORD_TYPE, ALL_CLIENT_CODE} from "../../util/constants";
    import {
        VALIDATE_SUCCESS_RES,
        getErrorMessage,
        VALIDATE_CAPTCHA_RES
    } from "@/util/apiValidate.js";
    import apiForgotPassword from '../../services/apiForgotPassword';
    import BaseConfiguration from "../../config/base";
    import {
        setIsIntroVisited,setBaseSettToLocal,
        getIsIntroVisited
    } from '../../applocalstorage/localStorage'
import { restartWebsockets } from '../../graphql/ApolloClient';
 import {initClientBasedSett} from '../../main'

    // localize({
    //     en: {
    //         messages: en.messages
    //     },
    //     nb: {
    //         messages: nb.messages
    //     }
    // });
    export default {
        name: COMPONENT_NAME.AGENT_LOGIN,
        components: {
            ValidationObserver,
            cTextInputComponent,
            cCaptcha,
            cAlertModal
        },
        data: () => ({
            isMobile: BaseConfiguration.isMobile,
            isIntroVisited: false,
            pwdRest: false,
            alertValue: null,
            showAlert: false,
            showCaptcha: false,
            showError: true,
            showLogin: true,
            resetPwd: false,
            forgotSub: false,
            frgtPwdAlert: null,
            logDet: {
                logMail: null,
                logPwd: null,
                captcha: null,
                captchaText: null
            },
            frgtPwd: {
                mail: null
            },
            regMail: null,
            pwdType: PASSWORD_TYPE.PASSWORD
        }),

        methods: {
            ...mapActions("sAgtLogin", ["SET_SIGNIN_REQ"]),
            ...mapActions("sAgtLogin", ["SET_SIGNIN_RES"]),
            ...mapActions("sAgtLogin", ["SET_JWT_TOKEN"]),
            ...mapActions("sAgtLogin", ["SET_FORGOTPWD"]),
            ...mapActions('sDashBoard',{
                SET_AGENT_LOGO_DET_RESPONSE:'SET_AGENT_LOGO_DET_RESPONSE',
                }),
            ...mapActions('sSettings',{
                SET_SETTINGS:'SET_SETTINGS',
                }),  
                
                
                
                introSlides() {
                    try {
                      if(BaseConfiguration.isDebug) console.log("introSlides");

                        setIsIntroVisited(true);
                      this.isIntroVisited = getIsIntroVisited();
                     
                
                    } catch (err) {
                            let body = Logger.buildRequest(
                              FILE_NAME.AGENT_LOGIN,
                              "error in introSlides",
                              err.toString(),
                              "introSlides",
                              LOG_TYPE.ERROR
                            );
                            Logger.getResponse(body);
                          }
                }, 

            navigateToReg: function () {
                navigate(
                    PATHNAME.AGENT_REGISTRATION
                );
            },

         /*   getImage(pCode) {
      let retValue
        try {
          if(BaseConfiguration.isDebug) console.log("getImage");
        //  if(BaseConfiguration.clientCode == ALL_CLIENT_CODE.AZ)
        //   retValue= "@/assets/az/img/png/Logo-Maing-Fong.jpg"
        //  else if(BaseConfiguration.clientCode == ALL_CLIENT_CODE.MF)
        //   retValue= "@imgPath/img/png/Logo-Maing-Fong.jpg"
        if(BaseConfiguration.clientCode == ALL_CLIENT_CODE.AZ) {
         var images = require.context(
                  "@/assets/az/img/png/",
                  false,
                  /\.jpg$/
              );
              return images("./" + "logo"+ ".jpg");
        }
        else if(BaseConfiguration.clientCode == ALL_CLIENT_CODE.MF) {
         var images = require.context(
                 "@imgPath/img/png/",
                  false,
                  /\.jpg$/
              );
              return images("./" + pCode+ ".jpg");
        }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.AGENT_LOGIN,
                  "error in getImage",
                  err.toString(),
                  "getImage",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         // return retValue;
      }, */


    captchaError() {
      
        try {
          if(BaseConfiguration.isDebug) console.log("captchaError");
          if(this.$refs.agtCaptchaComponent) {
            this.$refs.agtCaptchaComponent.newCaptcha();
            this.logDet.captcha=null;
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.AGENT_LOGIN,
                  "error in captchaError",
                  err.toString(),
                  "captchaError",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
    }, 

            navigateToLogin: function () {
                this.showLogin = true;
                this.resetPwd = false;
                this.pwdRest = false;
                this.frgtPwd.mail = null;
                navigate(
                   PATHNAME.AGENT_LOGIN
                );
            },

            togglePwdType(){
                if(this.pwdType == PASSWORD_TYPE.PASSWORD){
                    this.pwdType = PASSWORD_TYPE.TEXT;
                }else if(this.pwdType == PASSWORD_TYPE.TEXT){
                    this.pwdType = PASSWORD_TYPE.PASSWORD;
                }
            },

           async loginFormSubmit() {
                if(Object.keys(router.currentRoute.query).length != 0)
                {
                     await  updateCurrRouteQuery(null);

                }
            

                let signInRes = await this.getSignInStatus();
               
                   

            },

            async forgotFormSubmit() {
                //this.pwdRest = true;
               // this.resetPwd = true;
                this.showLogin = false;
                if (this.frgtPwd.mail) {
                    await this.getForgotPassword(this.frgtPwd.mail);
                    this.SET_FORGOTPWD(this.frgtPwd.mail);
                    this.regMail = this.forgotPwd;
                }
            },

            async getForgotPassword(pMail) {
                try {
                  if(BaseConfiguration.isDebug) console.log("getForgotPassword");
                 // let retValue;
                  let pswdReq = apiForgotPassword.buildRequest(pMail);

                    if (pswdReq) {
                        let pswdRes = await apiForgotPassword.getResponse(
                            pswdReq
                        );
                        if (VALIDATE_SUCCESS_RES(pswdRes)) {
                            this.frgtPwdAlert = null;
                            this.resetPwd = true;
                            this.pwdRest = true;
                            this.showAlert = false;
                            this.alertValue = null;
                            // this.showAcknowledgeAlert();
                        } else {
                            let error = getErrorMessage(pswdRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                //this.showAlert = true;
                                 this.resetPwd = false;
                                this.frgtPwdAlert = getErrorAlertValue(error);
                            }
                            
                        }
                    } else {
                        throw "invalid request";
                    }
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.AGENT_LOGIN,
                          "error in getForgotPassword",
                          err.toString(),
                          "getForgotPassword",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                 // return retValue;
                }, 

            //Get captcha list from API and store in vuex store

            async getSignInStatus() {
                let retValue;
                try {
                    //let langCode = get lang code

                    let signInRequest = apiSignIn.buildRequest(
                        this.logDet,
                        this.captchaText
                        // this.captchaRes &&
                        //   this.captchaRes.data &&
                        //   this.captchaRes.data.data &&
                        //   this.captchaRes.data.data.text
                        //   ? this.captchaRes.data.data.text
                        //   : null
                    );
                    if (signInRequest) {
                        this.SET_SIGNIN_REQ(signInRequest); //save req in store
                        //   console.log(JSON.stringify(signInRequest));
                        let signInResponse = await apiSignIn.getResponse(signInRequest);
                        if (VALIDATE_SUCCESS_RES(signInResponse)) {
                            //   console.log(JSON.stringify(signInResponse));
                           
                            if(signInResponse.data.data.logoDetails)
                            this.SET_AGENT_LOGO_DET_RESPONSE(signInResponse.data.data.logoDetails) //save logo details in store
                            this.SET_SIGNIN_RES(signInResponse.data.data);  //save res in store
                            this.showAlert = false;
                            retValue = signInResponse.data;
                            let settings = await getSettings();
                           if(settings && settings.setting){
                              this.SET_SETTINGS(settings.setting)
                              setBaseSettToLocal(settings.setting)
                              initClientBasedSett()
                           }
                             
                            //   navigate(
                            //     PATHNAME.DASHBOARD
                            // );
                            navigateReplace(PATHNAME.DASHBOARD);
                            //  router.replace({path:PATHNAME.DASHBOARD})
                           /* }else if(settings && settings.alertValue){
                               this.showAlert = true;
                               this.alertValue = settings.alertValue;
                           }   */                    
                            // this.SET_JWT_TOKEN(signInResponse.headers['authorization']);
                        } else {
                            if (BaseConfiguration.isDebug) console.log(JSON.stringify(signInResponse.data));
                            signInResponse.data.data
                                ? (this.showCaptcha = true)
                                : ((this.alertValue = getErrorMessage(
                                signInResponse
                                ).error[0].value),
                                    (this.showAlert= true));
                            if(this.showCaptcha==true){
                this.captchaError();
                }       
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.API_SIGN_IN,
                        "error in getting response from SignIn API",
                        err.toString(),
                        "getSignInResponse",
                        LOG_TYPE.ERROR
                    );
                   if (BaseConfiguration.isDebug) console.log("catch error");
                    Logger.getResponse(body);
                }
                return retValue;
            }
        },

        computed: {
            ...mapGetters("sCaptcha", {
                captchaRes: "GET_CAPTCHA_RES",
                captchaText: "GET_CAPTCHA_TEXT"
            }),
            ...mapGetters("sAgtLogin", {
                forgotPwd: "GET_FORGOTPWD"
                // id : "GET_B2BID"
            })
        },
    
        created() {
restartWebsockets(true);
           // document.title = this.$t('documentTitle.agent');
           this.isIntroVisited = getIsIntroVisited();
           document.title = "Agent Portal - B2B Flight Engine"
            if (
                router.currentRoute.query.param &&
                router.currentRoute.query.param.length > 0               
            ) {
                this.showAlert = true;
                // if(router.currentRoute.query.param[0] == HTTP_CODES.ERROR_JWT){
                // this.alertValue = router.currentRoute.query.param[1];
                // }else if(router.currentRoute.query.param[0] == HTTP_CODES.ERROR_PER){
                //    this.alertValue = router.currentRoute.query.param[1].value;
                // }
                // if(router.currentRoute.query.param[0] == (HTTP_CODES.ERROR_JWT_01 || HTTP_CODES.ERROR_JWT_02 || HTTP_CODES.ERROR_PER)){
                // this.alertValue = router.currentRoute.query.param[1];
                // }
                if(router.currentRoute.query.param[0] == HTTP_CODES.ERROR_JWT_01 ||
                router.currentRoute.query.param[0] == HTTP_CODES.ERROR_JWT_02 ||
                router.currentRoute.query.param[0] == HTTP_CODES.ERROR_AUT2 ||
                router.currentRoute.query.param[0] == HTTP_CODES.ERROR_PER){
                this.alertValue = router.currentRoute.query.param[1];
                }
            } else {
               
            
                this.showAlert = false;
            }
        },
         beforeCreate() {    
   addClassToBody(COMPONENT_NAME.AGENT_LOGIN);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
    };
</script>
<!--<style lang="scss">-->
<!--    .logo-wrapper span.brand-logo {-->
<!--        position: relative;-->
<!--        /*min-height: 120px;*/-->
<!--        /*min-width: 120px;*/-->
<!--        /*background: red;*/-->
<!--        /*margin: auto;*/-->
<!--        display: flex;-->
<!--        margin-top: 120px;-->
<!--        &:before{-->
<!--            position:absolute;-->
<!--            content:'';-->
<!--            min-height: 120px;-->
<!--            min-width: 120px;-->
<!--            max-height: 120px;-->
<!--            max-width: 120px;-->
<!--            /*background: red;*/-->
<!--            background-image: url("~@imgPath/img/png/Logo-Maing-Fong.jpg");-->
<!--            background-size: cover;-->
<!--            bottom: 0;-->
<!--            left: 0;-->
<!--            right: 0;-->
<!--            margin: auto;-->
<!--        }-->
<!--    }-->
<!--</style>-->

